import dayjs from 'dayjs';
import { Exception, ExceptionForm, ExceptionTableFilters } from './types';

export const defaultFilterObject: ExceptionTableFilters = {
  name: '',
  isAvailable: false,
  isUnavailable: false,
  dateRange: ['', ''],
  timeRange: ['', ''],
  isAllDay: false,
};

export const getToday = () => {
  return dayjs().format();
};

export const getTodayIsoDate = () => {
  return dayjs().toISOString().trim();
};

export const sortByDate = (exceptions?: Exception[]) => {
  return (
    exceptions?.sort((a, b) => {
      return a.startDateTime < b.startDateTime ? -1 : a.startDateTime > a.startDateTime ? 1 : 0;
    }) || []
  );
};

export const getDateTime = (start: string, end: string) => {
  if (start && end) {
    const dateFormat = 'MM-DD-YYYY';
    const timeFormat = 'hh:mma';

    const startString = dayjs(start);
    const endString = dayjs(end);

    const startDate = startString.format(dateFormat);
    const endDate = endString.format(dateFormat);
    const startTime = startString.format(timeFormat);
    const endTime = endString.format(timeFormat);

    return [startDate, endDate, startTime, endTime];
  }
  return [];
};

export const convertTimeForComparison = (time: string) => {
  if (time.includes('pm')) {
    return +time.substring(0, 2) + 12;
  }
  return +time.substring(0, 2);
};

export const getDisplayDate = (start: string, end: string) => {
  const yearFormat = 'YYYY';
  const dateFormat = 'MMM D';
  const startYear = dayjs(start).format(yearFormat);
  const startDate = dayjs(start).format(dateFormat);

  if (startYear !== dayjs(end).format(yearFormat)) {
    return `${dayjs(start).format('MMM D, YYYY')} - ${dayjs(end).format('MMM D, YYYY')}`;
  }
  if (startDate === dayjs(end).format(dateFormat)) {
    return `${dayjs(start).format('MMM D, YYYY')}`;
  }
  return `${dayjs(start).format(dateFormat)} - ${dayjs(end).format('MMM D, YYYY')}`;
};

export const getDateTimeString = (data: ExceptionTableFilters | ExceptionForm) => {
  const sd = dayjs(`${data?.dateRange[0]}`).format('YYYY-MM-DD');
  const ed = dayjs(`${data?.dateRange[1]}`).format('YYYY-MM-DD');

  if (data.timeRange[0] === '' && data.timeRange[1] === '') {
    data.timeRange = ['00:00:00', '23:59:00'];
  }

  return {
    startDateTime: dayjs(`${sd} ${data?.timeRange[0]}`).format(),
    endDateTime: dayjs(`${ed} ${data?.timeRange[1]}`).format(),
  } as Exception;
};

export const createDataTransferObject = (exception: ExceptionForm) => {
  const sd = dayjs(`${exception?.dateRange[0]}`).format('YYYY-MM-DD');
  const ed = dayjs(`${exception?.dateRange[1]}`).format('YYYY-MM-DD');

  if (exception.isAllDay) {
    exception.timeRange = ['00:00:00', '23:59:00'];
  }

  return {
    // Save an "empty" string instead of undefined if no value is input by the user
    name: exception?.name || ' ',
    isAvailable: exception?.isAvailable === 'true' ? true : false,
    startDateTime: dayjs(`${sd} ${exception?.timeRange[0]}`).format(),
    endDateTime: dayjs(`${ed} ${exception?.timeRange[1]}`).format(),
  } as Exception;
};

export const hasConflicts = (officeExceptions: Exception[], newException: ExceptionForm) => {
  const { startDateTime, endDateTime } = getDateTimeString(newException);

  const conflicts = officeExceptions.filter((item) => {
    return (
      !item.isAvailable && // only check for unavailable exceptions
      dayjs(item?.startDateTime).format() >= startDateTime &&
      dayjs(item?.endDateTime).format() <= endDateTime
    );
  });

  return conflicts.length === 0 ? false : true;
};
